import React from "react";
import ArtworkSwiper from "./ArtworkSwiper";
import "../css/YearSection.css"
import { useNavigate } from "react-router-dom";

export default function YearSection ({ id, year, featured, projects, onProjectClick }) {
    const projectEntries = Object.entries(projects).filter(
        ([projectName, elements]) => elements.length > 0 && projectName !== ""
    );
    const navigate = useNavigate();
    return (
        <section className="year-section" id={id}>
            <h2 className="year-header">{year}</h2>

            {featured.length > 0 && (
                <ArtworkSwiper artworks={featured} />
            )}

            <div className={projectEntries.length <= 3? "project-grid few-items": "project-grid"}>
                {projectEntries.map(([project, _]) => (
                    <div className="project-card" key={project} onClick={() => onProjectClick(project)}>
                        <h3>{project}</h3>
                    </div>
                ))}

                <div className="project-card" onClick={() => onProjectClick("")}>
                    <h3>Obras Independientes</h3>
                </div>
            </div>
                
            <button onClick={() => navigate(`/${year}`)}>Todo de {year}</button>

        </section>
    );
}
